module.exports = __webpack_public_path__ + "img/SL-M-160-200.54a22504.svg";